import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/CookieModal.css";

export default function CookieConfigModal({ onSave, onClose }) {
  const { t } = useTranslation();

  const [analytics, setAnalytics] = useState(false);
  const [personalization, setPersonalization] = useState(false);

  const saveSettings = () => {
    onSave({
      analytics,
      personalization,
    });
  };

  return (
    <div className="cookie-modal-overlay">
      <div className="cookie-modal" role="dialog" aria-modal="true">
        <h2>{t("cookies.modalTitle")}</h2>
        <p>{t("cookies.modalText")}</p>

        <div className="cookie-options">
          <label>
            <input type="checkbox" checked readOnly disabled />
            {t("cookies.necessaryCookies")}
          </label>
          <small>{t("cookies.necessaryCookiesDesc")}</small>

          <label>
            <input
              type="checkbox"
              checked={analytics}
              onChange={(e) => setAnalytics(e.target.checked)}
            />
            {t("cookies.analyticsCookies")}
          </label>
          <small>{t("cookies.analyticsCookiesDesc")}</small>

          <label>
            <input
              type="checkbox"
              checked={personalization}
              onChange={(e) => setPersonalization(e.target.checked)}
            />
            {t("cookies.personalizationCookies")}
          </label>
          <small>{t("cookies.personalizationCookiesDesc")}</small>
        </div>

        <div className="cookie-modal-buttons">
          <button className="save" onClick={saveSettings}>
            {t("cookies.saveSettings")}
          </button>

          <button className="cancel" onClick={onClose}>
            {t("cookies.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}